var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpayLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32Z",
    fill: "#262D30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 50.6658H29.7081C25.5868 50.6245 21.6484 48.9673 18.7488 46.0546C15.8492 43.1419 14.2227 39.2089 14.2227 35.1103C14.2227 31.0117 15.8492 27.0787 18.7488 24.1659C21.6484 21.2532 25.5868 19.5961 29.7081 19.5547H32.0005V25.6977H29.7081C27.219 25.7298 24.8429 26.7356 23.0942 28.4973C21.3454 30.259 20.3649 32.6348 20.3649 35.1103C20.3649 37.5857 21.3454 39.9615 23.0942 41.7232C24.8429 43.4849 27.219 44.4907 29.7081 44.5229H32.0005V50.6658Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44.4424H34.251C36.2825 44.4631 38.298 44.0761 40.1809 43.3037C42.0638 42.5313 43.7767 41.3889 45.2205 39.9424C46.6644 38.496 47.8105 36.7742 48.5928 34.8767C49.375 32.9792 49.7777 30.9436 49.7777 28.8876C49.7777 26.8316 49.375 24.796 48.5928 22.8985C47.8105 21.001 46.6644 19.2792 45.2205 17.8328C43.7767 16.3863 42.0638 15.2439 40.1809 14.4715C38.298 13.6991 36.2825 13.3121 34.251 13.3328H32V19.4691H34.251C35.4825 19.453 36.705 19.6845 37.8474 20.1502C38.9899 20.616 40.0295 21.3067 40.9061 22.1823C41.7826 23.0579 42.4786 24.1009 42.9536 25.2509C43.4287 26.4009 43.6733 27.6349 43.6733 28.8813C43.6733 30.1277 43.4287 31.3617 42.9536 32.5116C42.4786 33.6616 41.7826 34.7046 40.9061 35.5802C40.0295 36.4558 38.9899 37.1466 37.8474 37.6123C36.705 38.0781 35.4825 38.3096 34.251 38.2934H32V44.4424Z",
    fill: "#2445E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpayLogoSmall);
export default __webpack_public_path__ + "static/media/cpay_logo_small.45a83d99.svg";
export { ForwardRef as ReactComponent };